import axios from 'axios';
import { store } from './store';
import { SHOW_ERROR, SHOW_WARNING } from './actions/actionTypes';

let isGetActiveSessionRequest = false;
let requestQueue = [];

const callRequestsFromQueue = (_) => {
    requestQueue.forEach((sub) => sub());
};
const addRequestToQueue = (sub) => {
    requestQueue.push(sub);
};
const clearQueue = () => {
    isGetActiveSessionRequest = false;
    requestQueue = [];
};

axios.defaults.withCredentials = true;
const refreshToken = async () => await axios.get(process.env.REACT_APP_GATEWAY_URL_REFRESH_TOKEN);

axios.interceptors.request.use((config) => {
    config.params = config.params || {};
    config.params.modoOperacao = store.getState().modoOperacaoState.modo;
    return config;
});

axios.interceptors.response.use(null, (error) => {
    const { response = {}, config = {} } = error;

    if (response.status !== 401) {
        clearQueue();
    }

    if (response.status === 502) {
        store.dispatch({
            type: SHOW_WARNING,
            payload: `Ocorreu um problema na sua conexão. Aperte F5 para atualizar.`,
        });
        return Promise.reject(error);
    }

    if (response.status >= 500) {
        const {
            data: { server, message },
        } = error.response;
        store.dispatch({
            type: SHOW_ERROR,
            payload: `Ops! Servidor: ${server} Mensagem: ${message}`,
        });
        return Promise.reject(error);
    }

    if (response.status === 402 || response.status === 400) {
        axios.get(process.env.REACT_APP_GATEWAY_URL_REFRESH_COOKIE);
        window.location.href = '#/logout';
        return Promise.reject(error);
    }

    if (response.status === 401) {
        if (!isGetActiveSessionRequest) {
            isGetActiveSessionRequest = true;
            refreshToken()
                .then((_) => {
                    isGetActiveSessionRequest = false;
                    callRequestsFromQueue();
                    clearQueue();
                })
                .catch((e) => {
                    isGetActiveSessionRequest = false;
                    clearQueue();
                });
        }
        const retryRequest = new Promise((resolve) => addRequestToQueue((_) => resolve(axios(config))));
        return retryRequest;
    } else {
        return Promise.reject(error);
    }
});

export default axios;
